import { useState, type FormEvent } from 'react';
import { KeyRound, LogOut } from 'lucide-react';
import { api } from '../api';
import { useSessao } from '../sessao';
import logo from '../assets/logo-ondark.png';

/** Troca a própria senha. Depois da troca, as outras sessões do usuário (outros aparelhos) são encerradas. */
export function FormTrocarSenha({ aoTerminar, provisoria }: { aoTerminar: () => void; provisoria?: boolean }) {
  const { recarregar } = useSessao();
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [repete, setRepete] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const curta = nova.length > 0 && nova.length < 10;
  const diferente = repete.length > 0 && repete !== nova;

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null); setEnviando(true);
    try {
      await api('/auth/trocar-senha', { metodo: 'POST', corpo: { senha_atual: atual, senha_nova: nova } });
      setOk(true);
      await recarregar();
      if (!provisoria) setTimeout(aoTerminar, 1200);
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Não foi possível trocar a senha.');
    } finally { setEnviando(false); }
  }

  if (ok && !provisoria) return <div className="form"><p className="alerta alerta-ok" role="status">Senha trocada. Os outros aparelhos conectados com o seu usuário foram desconectados.</p></div>;

  return (
    <form className="form" onSubmit={enviar}>
      <label>{provisoria ? 'Senha provisória (a que você recebeu)' : 'Senha atual'}
        <input type="password" autoComplete="current-password" required value={atual} onChange={(e) => setAtual(e.target.value)} autoFocus />
      </label>
      <label>Nova senha
        <input type="password" autoComplete="new-password" required minLength={10} maxLength={200} value={nova} onChange={(e) => setNova(e.target.value)} aria-invalid={curta} />
        <small className="ajuda">Pelo menos 10 caracteres. Uma frase curta é mais fácil de lembrar e mais forte que uma palavra com símbolo.</small>
      </label>
      <label>Repita a nova senha
        <input type="password" autoComplete="new-password" required value={repete} onChange={(e) => setRepete(e.target.value)} aria-invalid={diferente} />
        {diferente && <small className="ajuda erro">As duas não conferem.</small>}
      </label>
      {erro && <p className="alerta" role="alert">{erro}</p>}
      <div className="acoes-form">
        {!provisoria && <button type="button" className="btn-fantasma" onClick={aoTerminar}>Cancelar</button>}
        <button className="btn" disabled={enviando || !atual || nova.length < 10 || nova !== repete}>{enviando ? 'Trocando…' : 'Trocar senha'}</button>
      </div>
    </form>
  );
}

/** Tela cheia depois de entrar com senha provisória: o sistema só libera depois da troca (o servidor também barra). */
export function TelaTrocarSenha() {
  const { usuario, sair } = useSessao();
  return (
    <div className="entrar">
      <section className="entrar-marca escuro">
        <img src={logo} alt="Vivium" className="entrar-logo" />
        <div>
          <span className="kicker">Primeiro acesso</span>
          <h1 className="titulo-display">Crie a sua <span>senha</span></h1>
          <p className="lead">Você entrou com uma senha provisória. Escolha uma senha só sua para continuar — ninguém da MAZA precisa saber qual é.</p>
        </div>
        <small className="endosso">Uma marca Maza Automação.</small>
      </section>
      <section className="entrar-form">
        <div className="cartao">
          <span className="kicker"><KeyRound size={14} aria-hidden /> {usuario?.email}</span>
          <h2 className="titulo">Nova senha</h2>
          <FormTrocarSenha provisoria aoTerminar={() => {}} />
          <button className="btn-link" onClick={sair}><LogOut size={14} aria-hidden /> Sair sem trocar</button>
        </div>
      </section>
    </div>
  );
}
